/** SAIT-135, 12.10.2026: тонкий слой ядра; группа с формой загружается только по нажатию «Подписаться». */
import { reactive, markRaw } from 'ui.vue3';

const EXTENSION = 'vpl.tas.newsletter';
const NAMESPACE = 'BX.Vpl.Newsletter';
export const newsletterState = reactive({ open: false, pending: false, source: 'footer', error: '', dialog: null, trigger: null });
let loadPromise = null;
let sequence = 0;
let waiting = false;

export function loadNewsletter() {
    if (!loadPromise) {
        if (typeof BX === 'undefined' || !BX.Runtime || typeof BX.Runtime.loadExtension !== 'function') {
            return Promise.reject(new Error('Загрузчик формы недоступен.'));
        }
        loadPromise = BX.Runtime.loadExtension(EXTENSION).then(() => {
            const group = BX.getClass(NAMESPACE);
            if (!group || !group.NewsletterDialog || !group.NewsletterForm) {
                throw new Error('Форма не загрузилась.');
            }
            return group;
        }).catch((error) => {
            loadPromise = null;
            throw error;
        });
    }
    return loadPromise;
}

function escapeWaiting(event) {
    if (event.key === 'Escape') {
        event.preventDefault();
        closeNewsletter();
    }
}
function finishWaiting() {
    waiting = false;
    newsletterState.pending = false;
    document.removeEventListener('keydown', escapeWaiting, true);
}

export async function openNewsletter(source) {
    if (newsletterState.pending || newsletterState.open) {
        return;
    }
    const current = ++sequence;
    newsletterState.source = source;
    newsletterState.trigger = document.activeElement ? markRaw(document.activeElement) : null;
    newsletterState.pending = true;
    newsletterState.error = '';
    waiting = true;
    document.addEventListener('keydown', escapeWaiting, true);
    try {
        const group = await loadNewsletter();
        if (current === sequence && waiting) {
            finishWaiting();
            newsletterState.dialog = markRaw(group.NewsletterDialog);
            newsletterState.open = true;
        }
    } catch (_) {
        if (current === sequence && waiting) {
            finishWaiting();
            newsletterState.error = 'Не удалось загрузить форму. Нажмите «Подписаться» ещё раз.';
        }
    }
}

export function closeNewsletter() {
    sequence += 1;
    finishWaiting();
    newsletterState.open = false;
}
